import { DialogActions } from "@material-ui/core"
import { PRE_STUDY_ACTIONS,COMMON_ACTION_TYPES } from "../../_constants"
import { exceptionHandler } from "../../_helpers"
import { StudyPreActivityDetail, StudyPreActivityFilterStructure, StudyPreActivityHeaders } from "../../_models/app.models"
import { preStudyService } from "../../_services/pre-study.service"

const getPreStudyStyles = (onSuccess, onError,plantCode:string,factoryCode:string,moduleCode:string,style:string) => {
    return action => {
        action({type: PRE_STUDY_ACTIONS.GET_STYLES + COMMON_ACTION_TYPES.REQUEST})
        preStudyService.getStyles(plantCode,factoryCode,moduleCode,style)
            .then( (res:any) => {
                const _data = res.data.style
                action({type: PRE_STUDY_ACTIONS.GET_STYLES + COMMON_ACTION_TYPES.SUCCESS, data: _data})
                onSuccess(_data)
            })
            .catch( (error) => {
                action({type: PRE_STUDY_ACTIONS.GET_STYLES + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getPreStudyHeaders = (id:number,preActivityStudyFilters:StudyPreActivityFilterStructure,onSuccess, onError) => {
    return action => {
        action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY + COMMON_ACTION_TYPES.REQUEST})
        preStudyService.getPreActivityStudyHeader(id,preActivityStudyFilters?.plantCode
            ,preActivityStudyFilters?.factoryCode,preActivityStudyFilters?.module,preActivityStudyFilters?.shiftCode
            ,preActivityStudyFilters?.style,preActivityStudyFilters?.styleVersion,true)
            .then( (res) => {
                const _data = res.data
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY + COMMON_ACTION_TYPES.SUCCESS, data: _data})
                onSuccess(_data)
            })
            .catch( (error) => {
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const addPreActivityStudyHeader = (input:StudyPreActivityHeaders,onSuccess, onError) => {
    return action => {
        action({type: PRE_STUDY_ACTIONS.ADD_PRE_ACTIVITY_STUDY + COMMON_ACTION_TYPES.REQUEST})
        preStudyService.addPreActivityStudyHeader(input)
            .then( (res) => {
                const _data = res.data
                action({type: PRE_STUDY_ACTIONS.ADD_PRE_ACTIVITY_STUDY + COMMON_ACTION_TYPES.SUCCESS, data: _data})
                onSuccess(_data)
            })
            .catch( (error) => {
                action({type: PRE_STUDY_ACTIONS.ADD_PRE_ACTIVITY_STUDY + COMMON_ACTION_TYPES.ERROR,data:input})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getGSDCodes = (onSuccess, onError,plantCode:string,factoryCode:string,moduleCode:string,style:string,styleVersion:string) => 
{
    return action => {
        action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_GSD_CODES + COMMON_ACTION_TYPES.REQUEST})
        preStudyService.getOperations(plantCode,factoryCode,moduleCode,style,styleVersion)
            .then( (res:any) => {                
                const _data = res.data.filter(x=>x.gsdCode!=null && x.gsdCode!=undefined && x.gsdCode.trim()!='')?.map(x=>{return {id:x.gsdCode,value:x.gsdCode}})
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_GSD_CODES + COMMON_ACTION_TYPES.SUCCESS, data: _data})
                onSuccess(_data)
            })
            .catch( (error) => {
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_GSD_CODES + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getOperations = (onSuccess, onError,plantCode:string,factoryCode:string,moduleCode:string,style:string,styleVersion:string) => 
{
    return action => {
        action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_OPERATIONS + COMMON_ACTION_TYPES.REQUEST})
        preStudyService.getOperations(plantCode,factoryCode,moduleCode,style,styleVersion)
            .then( (res:any) => {
                const _data = res.data.map(x=>{return {id:x.operationSeq,name:x.operationName,gsdCode:x.gsdCode}})
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_OPERATIONS + COMMON_ACTION_TYPES.SUCCESS, data: _data})
                onSuccess(_data)
            })
            .catch( (error) => {
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_OPERATIONS + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getElementCategory= (onSuccess, onError) => 
{
    //todo: need to correct this, currently this is fetching elemnt name id but need to change it to fetch element category id
    return action => {
        action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_CATEGORY + COMMON_ACTION_TYPES.REQUEST})
        preStudyService.getElementCategories()
            .then( (res:any) => {
                const _data = res.data.map(x=> {return {id:x.id,name:x.name}})
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_CATEGORY + COMMON_ACTION_TYPES.SUCCESS, data: _data})
                onSuccess(_data)
            })
            .catch( (error) => {
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_CATEGORY + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const getElementNames = (onSuccess, onError) => 
{
    
    return action => {
        action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_NAME + COMMON_ACTION_TYPES.REQUEST})
        preStudyService.getElementNames()
            .then( (res:any) => {
                const _data = res.data.map(x=>{return {id:x.id,name:x.name,categoryName:x.categoryName}})
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_NAME + COMMON_ACTION_TYPES.SUCCESS, data: _data})
                onSuccess(_data)
            })
            .catch( (error) => {
                action({type: PRE_STUDY_ACTIONS.GET_PRE_ACTIVITY_STUDY_ELEMENT_NAME + COMMON_ACTION_TYPES.ERROR})
                onError(exceptionHandler.catchError(error.response))
            })
    }
}

const changePreStudyPageState = (pageStateInput:string)=>
{
    return action=>{
        action({type:PRE_STUDY_ACTIONS.UPDATE_PAGE_STATE,data:pageStateInput});
    }
}

const updatePreStudyHeaderDetail = (preStudyHeaderDetail:StudyPreActivityHeaders)=>
{
    return action=>{
        action({type:PRE_STUDY_ACTIONS.SET_PRE_STUDY_HEADER_DETAIL,data:preStudyHeaderDetail});
    }
}

const updatePreStudyHeaderActivityDetails = (preStudyHeaderActivityDetails:StudyPreActivityDetail[])=>
{
    return action=>{
        action({type:PRE_STUDY_ACTIONS.SET_PRE_STUDY_HEADER_ACTIVITY_DETAILS,data:preStudyHeaderActivityDetails});
    }
}


export const preStudyActions =  {
    getPreStudyStyles,
    getPreStudyHeaders,
    addPreActivityStudyHeader,
    changePreStudyPageState,
    updatePreStudyHeaderDetail,
    updatePreStudyHeaderActivityDetails,
    getGSDCodes,
    getElementCategory,
    getElementNames,
    getOperations
}

